import React, { useState } from 'react'

import ClientPortalThemeProvider from './ClientPortalThemeProvider'

import JourneyWhiteLabelContext from 'contexts/JourneyWhiteLabelContext'

const JourneyWhiteLabelProvider = ({ children }) => {
  const [steps, setSteps] = useState([])
  const [currentStep, setCurrentStep] = useState(0)

  return (
    <ClientPortalThemeProvider>
      <JourneyWhiteLabelContext.Provider
        value={{
          steps,
          setSteps,
          currentStep,
          setCurrentStep,
        }}
      >
        {children}
      </JourneyWhiteLabelContext.Provider>
    </ClientPortalThemeProvider>
  )
}

export default JourneyWhiteLabelProvider
